
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1459 -6037)"}},[_c('circle',{attrs:{"data-name":"Ellipse 299","cx":"22","cy":"22","r":"22","transform":"translate(1459 6037)","fill":"none"}}),_c('path',{attrs:{"data-name":"Path 74","d":"M1485.935 6057.55h-3.287v12.061h-4.992v-12.061h-2.373v-4.238h2.373v-2.742a4.674 4.674 0 015.032-5.033l3.69.016v4.117h-2.677a1.015 1.015 0 00-1.058 1.155v2.494h3.728z"}})])])
          )
        }
      }
    